export enum RateRestrictionForms {
  Create = 'CreateRoomRateRestriction',
  Delete = 'DeleteRoomRateRestriction',
}
